import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { Contact, PaginatedApi } from '../../models/models'
import { UserAuthProvider } from '../../modules/mrk-user-auth/user-auth'

@Injectable()
export class ContactProvider {

  baseUrl: string;

  constructor(
    public http: HttpClient,
    private readonly userProvider: UserAuthProvider<any>) {
      this.baseUrl = this.userProvider.config.baseURL
      console.log('ContactProvider Init');
    }

    getHotContacts(search: string = null) {
      return this.getRecentContacts(search, true)
    }

    getRecentContacts(search: string = null, hot: boolean = false) {
      return this.getContacts(search, hot, true)
    }

    getContacts(search: string = null, hot: boolean = false, recent: boolean = false) {
      let params = new HttpParams();
      params = params.append('page_size', `${40}`)
      if (search != null) {
        params = params.append('search', search)
      }
      params = params.append('my', 'True')
      params = params.append('converting_product', "True")

      if (recent) {
        params = params.append('last_interaction', 'True')
      }

      params = params.append('not_converted', 'True')
      if (hot) {
        params = params.append('is_hot', 'True')
      }
      return this.http.get<PaginatedApi<Contact>>(this.baseUrl + "api/crm/contacts/", { params: params })
    }

    getNextContacts(url: string) {
      return this.http.get<PaginatedApi<Contact>>(url)
    }

    postContact(operatorId: number, contact: Contact, source_id) {
      let payload = {
        name: contact.name,
        surname: contact.surname,
        email: contact.email,
        phone: contact.phone,
        company: contact.company,
        city: '',
        source: source_id,
        source_operator: operatorId
      }
      return this.http.post<Contact>(this.baseUrl + "api/crm/contacts/", payload, {observe: 'response'})
    }

    updateContactOnAC(contact_id: number) {
      return this.http.post(this.baseUrl + "api/crm/contacts/" + contact_id + "/update_ac/", {})
    }


    updateContact(contactId: number, contact: Partial<Contact>) {
      return this.http.patch<Contact>(this.baseUrl + "api/crm/contacts/" + contactId + "/", contact)
    }

    postContactInList(contact_id: number, list_id: number) {
      let payload = { list_id: list_id }
      return this.http.post(this.baseUrl + "api/crm/contacts/" + contact_id + "/add_to_list/", payload)
    }
    pushOnAC(id: number): Observable<any> {
      const url = `${this.baseUrl}api/v2/contacts/${id}/push_on_ac/`
      return this.http.post<any>(url, {})
    }

  }



// WEBPACK FOOTER //
// ./src/providers/api/contacts.provider.ts